import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useOAuthParams = () => {
  const [searchParams] = useSearchParams();
  const oauthData = useMemo(() => {
    const data = {
      clientId: searchParams.get("client_id")!,
      scope: searchParams.get("scope")!,
      redirectUri: searchParams.get("redirect_uri")!,
      state: searchParams.get("state"),
      responseType: searchParams.get("response_type")!,
    };

    if (
      data.clientId != null &&
      data.redirectUri != null &&
      data.responseType != null &&
      data.scope != null
    ) {
      return data;
    }

    return null;
  }, [searchParams]);

  return oauthData;
};
